import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import WKTWriter from '../io/WKTWriter';
import CoordinateArraySequence from '../geom/impl/CoordinateArraySequence';
import Octant from './Octant';
import SegmentString from './SegmentString';
var BasicSegmentString = /*#__PURE__*/function () {
  function BasicSegmentString() {
    _classCallCheck(this, BasicSegmentString);
    BasicSegmentString.constructor_.apply(this, arguments);
  }
  _createClass(BasicSegmentString, [{
    key: "getCoordinates",
    value: function getCoordinates() {
      return this._pts;
    }
  }, {
    key: "size",
    value: function size() {
      return this._pts.length;
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate(i) {
      return this._pts[i];
    }
  }, {
    key: "isClosed",
    value: function isClosed() {
      return this._pts[0].equals(this._pts[this._pts.length - 1]);
    }
  }, {
    key: "getSegmentOctant",
    value: function getSegmentOctant(index) {
      if (index === this._pts.length - 1) return -1;
      return Octant.octant(this.getCoordinate(index), this.getCoordinate(index + 1));
    }
  }, {
    key: "setData",
    value: function setData(data) {
      this._data = data;
    }
  }, {
    key: "getData",
    value: function getData() {
      return this._data;
    }
  }, {
    key: "toString",
    value: function toString() {
      return WKTWriter.toLineString(new CoordinateArraySequence(this._pts));
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [SegmentString];
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._pts = null;
      this._data = null;
      var pts = arguments[0],
        data = arguments[1];
      this._pts = pts;
      this._data = data;
    }
  }]);
  return BasicSegmentString;
}();
export { BasicSegmentString as default };